import { observer } from 'mobx-react-lite'
import React from 'react'
import { Divider, Icon, Typography } from 'shared/ui'
import { getSalesmsgTypeFormLink } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IActiveTab } from 'pages/settings/pages/compliance/store/types'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import { type IStatusShortProps, StatusSection } from './StatusSection/StatusSection'
import styles from './styles.module.scss'

export const Menu = observer(() => {
  const { featureFlagsStore, usersStore, organizationStore } = useEntitiesContext()
  const { getIconConditionByTab, verificationItems, getIconInternationalByTab } =
    useCompliancePageContext()
  const { required, recommended, optional, international } = verificationItems
  const { uk_compliance } = featureFlagsStore

  const generateVerificationItems = (
    items: IActiveTab[],
    tabMapping: Record<IActiveTab, string>
  ): IStatusShortProps[] =>
    items.map((item) => {
      const iconProps = getIconConditionByTab(item)
      const titleIcon = getIconInternationalByTab(item)

      return {
        title: tabMapping[item],
        icon: iconProps?.icon,
        iconColor: iconProps?.iconColor,
        customIcon: iconProps?.customIcon,
        tab: item,
        ...(titleIcon && { titleIcon: titleIcon }),
      }
    })

  const tabMapping: Record<IActiveTab, string> = {
    BP: 'Business profile',
    LN: 'Local numbers',
    Calling: 'Calling',
    TF: 'Toll-free numbers',
    UK: 'United Kingdom',
  }

  const requiredVerificationItems = generateVerificationItems(required, tabMapping)
  const recommendedVerificationItems = generateVerificationItems(recommended, tabMapping)
  const optionalVerificationItems = generateVerificationItems(optional, tabMapping)
  const internationalVerificationItems = generateVerificationItems(international, tabMapping)

  return (
    <div className={styles.wrap}>
      <StatusSection
        title='Required'
        titleClassName={styles.requiredVerificationTitle}
        items={requiredVerificationItems}
      />
      <StatusSection
        title='Recommended'
        items={recommendedVerificationItems}
        titleClassName={styles.verificationTitle}
      />
      <StatusSection
        title='Optional'
        items={optionalVerificationItems}
        titleClassName={styles.verificationTitle}
      />
      {uk_compliance && (
        <>
          <Divider style={{ margin: '20px 8px' }} />
          <StatusSection
            title='International'
            items={internationalVerificationItems}
            titleClassName={styles.verificationTitle}
            showLabelNew
          />
          {!!usersStore.user?.email && !!organizationStore.id && !!usersStore.user?.id && (
            <a
              href={getSalesmsgTypeFormLink({
                email: usersStore.user.email,
                org_id: organizationStore.id,
                user_id: usersStore.user.id,
              })}
              target={'_blank'}
              rel='noreferrer'
              className={styles.button}
            >
              <div className={styles.iconWrap}>
                <Icon icon='add' color={'var(--content-primary-tertiary)'} />
              </div>
              <Typography
                variant={'body-md-regular'}
                ariaLabel={'Request a country'}
                color={'var(--content-primary-primary)'}
              >
                Request a country
              </Typography>
            </a>
          )}
        </>
      )}
    </div>
  )
})
